<div class="header">
    <div class="header-left">
        <a class="back" routerLink="../select" data-test="all-media-add-back">
            <i class="pi pi-arrow-left"></i>
        </a>
        <h2>{{ title() }}</h2>
    </div>
    <button class="close" type="button" [attr.aria-label]="'common.close' | translate" data-test="all-media-add-close" (click)="close()">
        <i class="pi pi-times"></i>
    </button>
</div>

<form [formGroup]="form" (ngSubmit)="onSubmit()" class="body" autocomplete="off">
    <div class="section">
        <h2>{{ 'media.fieldset.basic' | translate }}</h2>
        <app-form-input
            [control]="form.controls.name"
            [label]="'media.form.name' | translate"
            [placeholder]="'media.form.name.placeholder' | translate"
            inputId="name"
            testId="all-media-add-name"
        />
    </div>

    <div class="section">
        <h2>{{ 'media.fieldset.source' | translate }}</h2>
        <div class="col">
            @if (type === 'text') {
                <app-form-wysiwyg
                    [control]="form.controls.content"
                    [label]="'media.form.content' | translate"
                    inputId="content"
                    testId="all-media-add-content"
                />
                <app-form-number
                    [control]="form.controls.duration"
                    [label]="'media.form.duration' | translate"
                    inputId="duration"
                    testId="all-media-add-duration"
                />
            } @else {
                <app-form-file-upload
                    [control]="form.controls.mediaId"
                    [label]="'media.form.file' | translate"
                    [type]="type"
                    [accept]="fileAccept()"
                    [aspectRatio]="type === 'video' ? '16/9' : null"
                    inputId="file"
                    testId="all-media-add-file"
                />
            }
        </div>
    </div>
</form>

<div class="footer">
    <p-button [label]="'media.form.cancel' | translate" [outlined]="true" severity="secondary" data-test="all-media-add-cancel" (onClick)="close()" />
    <p-button
        type="submit"
        [label]="'media.form.create' | translate"
        [loading]="saving()"
        [disabled]="form.disabled"
        data-test="all-media-add-submit"
        (onClick)="onSubmit()"
    />
</div>
